import { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { FaInfoCircle } from 'react-icons/fa'

import { useAppStatus } from '@/providers/firebase/Firebase.provider'

import { Callout } from '../Typography/Callout'

import { CustomMessage } from './_CustomMessage'
import { FeatureDisabled } from './_FeatureDisabled'
import { getFeatureDisabled } from './helper'

import './AppStatusBadge.scss'

export const AppStatusBadge = () => {
  const [hidePopup, toggleHidePopup] = useReducer((x) => !x, true)
  const { t, i18n } = useTranslation()

  const {
    auctionAreEnabled,
    customMessage,
    displayCustomMessage,
    flashSalesAreEnabled,
    giveawaysAreEnabled,
    shipmentsAreEnabled,
    statusTitle,
  } = useAppStatus()

  const currentLanguage = (i18n.language || 'en').split('-')[0]

  const features = { flashSalesAreEnabled, giveawaysAreEnabled, shipmentsAreEnabled, auctionAreEnabled }
  const featuresDisabled = getFeatureDisabled(features)

  const shouldDisplaySomething = featuresDisabled.length || displayCustomMessage

  if (!shouldDisplaySomething) {
    return null
  }

  const correspondingTitle = {
    en: statusTitle.en,
    de: statusTitle.de,
    fr: statusTitle.fr,
  }[currentLanguage]

  const title = displayCustomMessage && correspondingTitle !== '' ? correspondingTitle : t('AppStatusBadgeTitle')

  return (
    <>
      <div className="app-status-bar" onClick={toggleHidePopup}>
        <span className="label">⚠️ {title} ⚠️</span>
      </div>
      {hidePopup ? null : (
        <div className="app-status-badge-wrapper" onClick={toggleHidePopup}>
          <FaInfoCircle className="icon" />
          <div className="app-status-badge-content">
            <Callout className="text-current" variant="callout2">
              {title}
            </Callout>
            <CustomMessage {...customMessage} displayCustomMessage={displayCustomMessage} />
            <FeatureDisabled featuresDisabled={featuresDisabled} />
          </div>
        </div>
      )}
    </>
  )
}
